import { RoundedToValue } from 'types/dataHelios';

export const roundedToNumber: Record<RoundedToValue, number> = {
  [RoundedToValue.TenThousandths]: 4,
  [RoundedToValue.Thousandths]: 3,
  [RoundedToValue.Hundredths]: 2,
  [RoundedToValue.Tenths]: 1,
  [RoundedToValue.Dozens]: -1,
  [RoundedToValue.Hundreds]: -2,
  [RoundedToValue.Thousands]: -3,
};

/**
 * Rounds a numeric value to the precision defined by `roundTo`, using the given
 * math-round mode. Mirrors the BE `HeliosDataFormatter.FormatValueNumber`
 * (EMathRound + ERoundTo) so FE display/edit matches backend output. Supports
 * negative precision (Dozens/Hundreds/Thousands).
 */
export const roundHeliosNumber = (value: number, roundTo: string, mathRound?: string | null): number => {
  const digits = roundedToNumber[roundTo as RoundedToValue];
  if (digits === undefined) {
    return value;
  }

  const factor = 10 ** digits;
  const scaled = value * factor;
  const epsilon = Math.abs(scaled) * Number.EPSILON * 4;

  switch (mathRound) {
    case 'Up':
      return Math.ceil(scaled - epsilon) / factor;
    case 'Down':
      return Math.floor(scaled + epsilon) / factor;
    default:
      // Arithmetic (Math.Round): sign-based midpoint-away-from-zero.
      return (Math.sign(value) * Math.round(Math.abs(scaled) + epsilon)) / factor;
  }
};
